import { type ValidationMode } from '@wix/ambassador-forms-v1-validation-result/types';
import { type Form } from '@wix/ambassador-forms-v4-form/types';
import { type AddressTemplate } from '@wix/form-fields';

import { type FormValues } from '../types';

const getFormValidator = async (
  form: Form,
  addressTemplates?: AddressTemplate[],
  validationMode?: ValidationMode,
) => {
  const [{ FormValidator }, { MultilineAddressToolkit }] = await Promise.all([
    import(/* webpackChunkName: "form-validator" */ '@wix/form-validator'),
    import(
      /* webpackChunkName: "form-multiline-address" */ '@wix/form-multiline-address'
    ),
  ]);

  if (addressTemplates?.length) {
    const addressForms = addressTemplates.map((template) => template.template);
    const addressToolkit = new MultilineAddressToolkit(addressForms as Form[]);

    return new FormValidator(
      [form],
      validationMode,
      false,
      addressToolkit.getFormForValidation,
      addressToolkit.normalizeEmptyValues,
      true,
    );
  }
  return new FormValidator(
    [form],
    validationMode,
    undefined,
    undefined,
    undefined,
    true,
  );
};

export const validate = async (
  form: Form,
  values: FormValues,
  addressTemplates?: AddressTemplate[],
  validationMode?: ValidationMode,
) => {
  if (!form.id) {
    return;
  }

  const formValidator = await getFormValidator(
    form,
    addressTemplates,
    validationMode,
  );

  return formValidator.validate(form.id, values);
};

export const validateFields = async (
  form: Form,
  values: FormValues,
  addressTemplates?: AddressTemplate[],
  validationMode?: ValidationMode,
) => {
  if (!form.id) {
    return;
  }

  const formValidator = await getFormValidator(
    form,
    addressTemplates,
    validationMode,
  );

  return formValidator.validateFields(form.id, values);
};
